import(/* webpackMode: "eager" */ "/workspace/src/app/events/2024techfes/lecture/page.tsx");
